module.exports = __webpack_public_path__ + "img/8_Fenntarthatosagi_kezikonyv.a9a0bb5b.png";